t = require('views/internal/teacup-with-helpers')('sticker_pack_selection_list')

module.exports = ->
  t.h2 ->
    t.text t.mustacheVar('displayName')

  t.div '.sticker-list.u-clearfix.js-sticker-list.u-relative'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/sticker_pack_selection_list.coffee